import { render, staticRenderFns } from "./DeactivateCardHolderDialog.vue?vue&type=template&id=214a3241"
import script from "./DeactivateCardHolderDialog.vue?vue&type=script&lang=js"
export * from "./DeactivateCardHolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports